/**
 * Gift Builder — Section-Level Min/Max with Free Individual Qty
 *
 * RULES:
 * - Each item's +/- can go from 0 up to its inventory
 * - Each section's TOTAL qty must be >= min and <= max
 * - Add to Cart is DISABLED until ALL gift builder sections meet their min
 * - Live counter + status badge in each section header
 */
(function () {
  document.addEventListener("DOMContentLoaded", function () {

    var wrappers = document.querySelectorAll(".gb-wrapper");

    // If no gift builder on this page, do nothing
    if (wrappers.length === 0) return;

    // Find the Add to Cart button
    var addToCartBtn =
      document.querySelector('button[name="add"].product-form__submit') ||
      document.querySelector('button.product-form__submit') ||
      document.querySelector('.product-form__submit') ||
      document.querySelector('form[id^="product-form"] button[type="submit"]');

    // Save original button text
    var originalBtnText = "";
    if (addToCartBtn) {
      var btnSpan = addToCartBtn.querySelector("span");
      originalBtnText = (btnSpan || addToCartBtn).textContent.trim();
    }

    /**
     * Main update function — called on every +/- click
     */
    function updateGiftBuilderState() {
      var allSectionsValid = true;

      wrappers.forEach(function (wrapper) {
        var min = parseInt(wrapper.dataset.min, 10) || 0;
        var max = parseInt(wrapper.dataset.max, 10) || 9999;
        var items = wrapper.querySelectorAll(".gb-item");

        var sectionTotal = 0;

        // ── Step 1: Count total qty in this section ──
        items.forEach(function (item) {
          var countEl = item.querySelector(".gb-count");
          var qty = parseInt(countEl.textContent, 10) || 0;
          sectionTotal += qty;

          // Minus disabled at 0
          var minusBtn = item.querySelector(".gb-minus");
          if (minusBtn) {
            minusBtn.disabled = qty <= 0;
          }
        });

        // ── Step 2: Enforce max — disable plus when section full ──
        var isMaxReached = sectionTotal >= max;

        items.forEach(function (item) {
          var plusBtn = item.querySelector(".gb-plus");
          if (!plusBtn) return;

          var isAvailable = item.dataset.available !== "false";
          var inventory = parseInt(item.dataset.inventory, 10);
          var currentQty = parseInt(item.querySelector(".gb-count").textContent, 10) || 0;
          var invReached = !isNaN(inventory) && inventory > 0 && currentQty >= inventory;

          plusBtn.disabled = isMaxReached || !isAvailable || invReached;
        });

        // ── Step 3: Check if section meets minimum ──
        var sectionValid = sectionTotal >= min;
        if (!sectionValid) {
          allSectionsValid = false;
        }

        // ── Step 4: Update the accordion header UI ──
        var accordion = wrapper.closest(".gift-builder-accordion");
        if (accordion) {
          // Update counter number
          var counterEl = accordion.querySelector(".gb-current-count");
          if (counterEl) {
            counterEl.textContent = sectionTotal;
          }

          // Update status badge
          var badge = accordion.querySelector(".gb-status-badge");
          if (badge) {
            if (sectionTotal < min) {
              var remaining = min - sectionTotal;
              badge.textContent = "Need " + remaining + " more";
              badge.className = "gb-status-badge gb-incomplete";
            } else if (isMaxReached) {
              badge.textContent = "Max reached";
              badge.className = "gb-status-badge gb-full";
            } else {
              badge.textContent = "\u2713 Done";
              badge.className = "gb-status-badge gb-complete";
            }
          }

          // Accordion border indicator
          if (sectionValid) {
            accordion.classList.add("section-complete");
            accordion.classList.remove("section-incomplete");
          } else {
            accordion.classList.add("section-incomplete");
            accordion.classList.remove("section-complete");
          }
        }
      });

      // ── Step 5: Add to Cart button state ──
      if (addToCartBtn) {
        if (!allSectionsValid) {
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add("gb-btn-disabled");
          var span = addToCartBtn.querySelector("span") || addToCartBtn;
          span.textContent = "Complete all selections";
        } else {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove("gb-btn-disabled");
          var span2 = addToCartBtn.querySelector("span") || addToCartBtn;
          span2.textContent = originalBtnText || "Add to cart";
        }
      }
    }

    // ── Click Handler (Event Delegation) ──
    document.addEventListener("click", function (e) {
      var plusBtn = e.target.closest(".gb-plus");
      var minusBtn = e.target.closest(".gb-minus");

      if (plusBtn && !plusBtn.disabled) {
        var countEl = plusBtn.parentElement.querySelector(".gb-count");
        var current = parseInt(countEl.textContent, 10) || 0;
        countEl.textContent = current + 1;
        updateGiftBuilderState();
      }

      if (minusBtn && !minusBtn.disabled) {
        var countEl2 = minusBtn.parentElement.querySelector(".gb-count");
        var current2 = parseInt(countEl2.textContent, 10) || 0;
        if (current2 > 0) {
          countEl2.textContent = current2 - 1;
          updateGiftBuilderState();
        }
      }
    });

    // ── Run once on page load ──
    updateGiftBuilderState();
  });
})();